import { render, staticRenderFns } from "./manage_h5.vue?vue&type=template&id=3f2b84f3&scoped=true&"
import script from "./manage_h5.vue?vue&type=script&lang=js&"
export * from "./manage_h5.vue?vue&type=script&lang=js&"
import style0 from "./manage_h5.vue?vue&type=style&index=0&id=3f2b84f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2b84f3",
  null
  
)

export default component.exports